@if (errorTitle) {
  <nz-collapse nzGhost>
    <nz-collapse-panel [nzHeader]="titleTemplate" nzShowArrow="false" [ngStyle]="errorStyle">
      <p>{{ errorMessage }}</p>
    </nz-collapse-panel>
  </nz-collapse>
}

<ng-template #titleTemplate>
  @if (errorTitle || errorMessage) {
    <nz-alert nzShowIcon [nzType]="type" nzMessage="{{ errorTitle }}" [nzDescription]="errorMessage"></nz-alert>
  }
</ng-template>
